import { createContext } from 'react';
import { getSubscriptionManager } from '@uniformdev/optimize-common-sitecore';
export var UniformContext = createContext({
  subscriptions: getSubscriptionManager("UNIFORM_CONTEXT_SUBS"),
  when: new Date()
});